import { isFiniteNumber } from '@/util';

export function formatNumberSign(value: number | undefined): string {
    if (isFiniteNumber(value)) {
        return value > 0 ? '+' + value: value.toString();
    } else {
        return '--';
    }
}